<template>
  <div>
    <confirmation-dialog ref="confirm" />
    <router-view />
  </div>
</template>

<script>
import { ConfirmationDialog } from "@/app/shared/components";
import { fetchItems } from "@/app/options/shared/services";
export default {
  name: "app",
  components: {
    ConfirmationDialog
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open;
  },
  created() {
    this.preFetchOptions();
  },
  methods: {
    async preFetchOptions() {
      let response = await fetchItems();
      let options = {};
      response.data.forEach(element => (options[element.key] = element.value));
      this.$store.commit("SET_OPTIONS", options);
      document.title = this.$store.state.modules.options.app_name
        ? this.$store.state.modules.options.app_name
        : "JD Projects";
    }
  }
};
</script>

<style></style>
